module.exports = __webpack_public_path__ + "static/media/prudential.ceb3fdce.jpg";